import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function CollegeSeatMapping() {


  const [sectionData, setSectionData] = useState([]);
  const [sectionId, setSectionId] = useState(false);
  const [sectionUserData, setSectionUserData] = useState([]);
  const [seatId, setSelectedSeatId] = useState(false);
  const [sectionCollegeData, setSectionCollegeData] = useState([]);
  const [selectedColleges, setSelectedColleges] = useState([]);
  const [isFirstSubmit, setFirstSubmit] = useState(false);

  const [disipline, setDisipline] = useState([]);
  const [selectedDisiplines, setSelectedDisiplines] = useState([]);





  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }




  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/Admin/getSection`);
        setSectionData(response.data.result);

      } catch (error) {

        if (error.response?.data?.http_status === 401 && error.response?.data?.status_code === "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/admin/");
          }, 5000);
        } else if (error.response?.data?.message?.http_status === 429 && error.response?.data?.message?.status_code === "ERR33") {
          toast.error(error.response.data.message.message);
        } else {
          toast.error("Something went wrong");
        }
        console.error('Error fetching Section data:', error);
      }
    };

    fetchData();
  }, [sectionId]);


  const handleSectionDataChange = async (selectedOption) => {

    const selectedSectionId = selectedOption.value;
    setSelectedSeatId(false);
    setSectionCollegeData([]);
    setSectionId(selectedSectionId);

  };

  useEffect(() => {

    const fetchData = async () => {

      try {
        const response = await http.get('/Admin/getSectionUser', {
          params: { section_id: sectionId },
        });
        setSectionUserData(response.data.result);

      } catch (error) {

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      }

    };
    if (sectionId) {
      fetchData();
    }

  }, [sectionId]);

  const handleStaffDataChange = (selectedOption) => {

    setSelectedSeatId(selectedOption);

  };

  useEffect(() => {
    const fetchData = async () => {

      try {
        const response = await http.get('/Admin/getSectionCollege', {
          params: {
            section_id: sectionId,
            seat_id: seatId.value
          },
        });

        let filteredColleges = []

        response.data.result.forEach(element => {

          if(element.stat > 0 || element.selected_count < element.count){
            filteredColleges.push(element);
          }

        });
          


        setSectionCollegeData(filteredColleges);
        setSelectedColleges([]);
        setSelectedDisiplines([]);


      } catch (error) {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      }
    };
    if (seatId) {
      fetchData();
    }


  }, [seatId]);



  useEffect(() => {

    const matchingColleges = sectionCollegeData

      .filter(college => college.stat > 0)
      .map(college => ({
        college_id: college.college_id,
        college_name: college.college_name
      }));


    const selectedColleges123 = matchingColleges.map(college => college.college_id);

    if (selectedColleges123.length > 0) {

      http.get(`/Admin/getSectionDiscipline`,
        {
          params: {
            selectedColleges: selectedColleges123,
            seat_id: seatId.value
          }
        }).then(response => {

          const matchingDisiplines = response.data.result.filter(disipline => disipline.seatCd === seatId.value || disipline.seatCd === null);
          setDisipline(matchingDisiplines);
          console.log(matchingDisiplines);
        }).catch(error => {
          console.log(error);
        });


    }

    setSelectedColleges(matchingColleges);

  }, [seatId, sectionCollegeData]);

  useEffect(() => {

    const matchingDisiplines = disipline

      .filter(disipline => disipline.seatCd === seatId.value)
      .map(disipline => ({
        discipline_id: disipline.discipline_id,
        discipline_name: disipline.combined_name,
        college_id: disipline.college_id,
        id : disipline.discipline_id,
        college_course_type : disipline.college_course_type
      }));

    setSelectedDisiplines(matchingDisiplines);




  }, [seatId, disipline]);


  const handleCollegeSelectChange = async (selectedOptions) => {

    const selectedColleges = selectedOptions.map(option => ({
      college_id: option.value,
      college_name: option.label
    }));

    const selectedColleges123 = selectedColleges.map(college => college.college_id);
    setSelectedDisiplines([]);

    if (selectedColleges123.length > 0) {

      http.get(`/Admin/getSectionDiscipline`,
        {
          params: {
            selectedColleges: selectedColleges123,
            seat_id: seatId.value
          }
        }).then(response => {

          const matchingDisiplines = response.data.result.filter(disipline => disipline.seatCd === seatId.value || disipline.seatCd === null);
          setDisipline(matchingDisiplines);
          console.log(matchingDisiplines);
        }).catch(error => {
          console.log(error);
        });


    }


    setSelectedColleges(selectedColleges);


  };

  const handleDisiplineSelectChange = async (selectedOptions) => {

   

    const selectedDisiplines = selectedOptions.map(option => ({

      discipline_id: option.id,
      discipline_name: option.label,
      college_id: option.college_id,
      id: option.id,
      college_course_type : option.college_course_type

    }));

    setSelectedDisiplines(selectedDisiplines);
  }

  const handlefirstsubmit = () => {

    setFirstSubmit(!isFirstSubmit);

  }


  const handleSubmitData = async (e) => {
    e.preventDefault();

    setFirstSubmit(!isFirstSubmit);

    const collegeIds = selectedColleges.map(college => college.college_id);

    const disiplines = selectedDisiplines.map(disipline => ({
      college_id: disipline.college_id,
      discipline_id: disipline.id,
      college_course_type : disipline.college_course_type
    }));


    const payload = {

      seat_id: seatId.value,
      college_id: collegeIds,
      discipline_id: disiplines

    };

    try {

      const response = await http.post('/Admin/saveSectionbaskets', payload);

      if (response.data.status_code === 'MSG1') {
        toast.success('Section Data saved successfully');
      } else {
        toast.error('Failed to save Section Data');
      }

    } catch (error) {
      toast.error('Something went wrong while saving the section basket');
      console.error('Error:', error);
    }
  };


  /* eslint-disable no-restricted-globals */

  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="table-responsive">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>College Seat Mapping</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="card-body custom-input">
                          <div className="row">
                            <div className="col">
                              <div className="mb-3 row">

                                <div className="col-md-6">
                                  <label className="">Section Name<span className="errorclr">*</span></label>


                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="section_id"
                                    name="section_id"
                                    styles={customStyles}
                                    className="form"

                                    options={sectionData
                                      .map(sectiondata => ({
                                        value: sectiondata.section_id,
                                        label: sectiondata.section_name
                                      }))

                                    }

                                    onChange={handleSectionDataChange}
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label className="">Seats<span className="errorclr">*</span></label>


                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="user_id"
                                    name="user_id"
                                    styles={customStyles}
                                    className="form"

                                    options={sectionUserData
                                      .map(sectionuserdata => ({
                                        value: sectionuserdata.seatCd,
                                        label: `${sectionuserdata.seat_name} - ${sectionuserdata.seat_desc}`
                                      }))

                                    }

                                    value={seatId}
                                    onChange={handleStaffDataChange}
                                  />
                                </div>

                              </div>

                              <div className="pgm-map-box mb-4  " style={{ zIndex: '1200' }}>

                                {sectionCollegeData && sectionCollegeData.length > 0 ? (
                                  <table className="display dataTable table-striped table-bordered">


                                    <tbody>
                                      <tr>
                                        <td>Colleges</td>
                                        <td>

                                          <Select
                                            id="minor_select"
                                            name="minor_select"
                                            maxMenuHeight={200}
                                            menuPlacement="auto"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={sectionCollegeData.map(college => ({
                                              value: college.college_id,
                                              label: college.college_name
                                            }))}


                                            value={selectedColleges.map(selecteds => ({
                                              value: selecteds.college_id,
                                              label: selecteds.college_name
                                            })
                                            )}

                                            onChange={handleCollegeSelectChange}
                                          />

                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Disiplines</td>
                                        <td>

                                          <Select
                                            id="minor_select"
                                            name="minor_select"
                                            maxMenuHeight={200}
                                            menuPlacement="auto"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti

                                            options={disipline.map(disipline => ({

                                              value: `${disipline.discipline_id}_${disipline.college_course_type}_${disipline.college_id}`,
                                              label: disipline.combined_name,
                                              college_id: disipline.college_id,
                                              id : disipline.discipline_id,
                                              college_course_type : disipline.college_course_type

                                            }))}

                                            value={selectedDisiplines.map(selecteds => ({
                                              value: `${selecteds.discipline_id}_${selecteds.college_course_type}_${selecteds.college_id}`,
                                              label: selecteds.discipline_name,
                                              college_id: selecteds.college_id,
                                              id : selecteds.discipline_id,
                                              college_course_type : selecteds.college_course_type
                                            })
                                            )}

                                            onChange={handleDisiplineSelectChange}
                                          />

                                        </td>
                                      </tr>


                                    </tbody>

                                  </table>
                                ) : (
                                  <div className="text-center mt-1">
                                    <h7>No data found</h7>
                                  </div>
                                )}



                                <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                                  <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                      <div className="modal-body">
                                        <div className="modal-toggle-wrapper">

                                          <h4 className="text-center pb-2">Are you sure you want to proceed?</h4>

                                          <div className="d-flex justify-content-center mt-3">

                                            <div>
                                              <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Submit</button>
                                              <button
                                                className="btn"
                                                style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                data-bs-dismiss="modal"
                                                onClick={handleCancel}
                                              >
                                                Cancel
                                              </button>
                                            </div>



                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                              {sectionCollegeData && sectionCollegeData.length > 0 && (
                                <div className="col-md-12 txt-aln pdg11">

                                  <div>
                                    <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                                    <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                                  </div>

                                </div>
                              )

                              }

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
